/**
 * Delayed Withdrawals Routes.
 */
export const delayedWithdrawals = {
  toggleSetting: '/delayed-withdrawals/toggle-setting',
}
